import ReactCSSTransitionGroup from 'react-addons-css-transition-group';

import * as segmentAnalytics from '~/lib/segmentAnalytics';

import NPS from './NPS';
import styles from './styles';

const ConnectedNPS = (props) => {
  // We need to keep the selected score in state so we can determine whether
  // or not the user selected a score when they dismiss the survey.
  const [selectedScore, setSelectedScore] = useState();
  const [showNPS, setShowNPS] = useState();
  const [submitted, setSubmitted] = useState();

  const onShowNPS = () => setShowNPS(true);

  useEffect(() => {
    window.addEventListener('clearbit.showXNPSSurvey', onShowNPS);

    return () =>
      window.removeEventListener('clearbit.showXNPSSurvey', onShowNPS);
  }, []);

  // After submitting a comment, we want to close the form after a timeout.
  useEffect(() => {
    let timer;

    if (submitted) {
      timer = setTimeout(() => {
        setShowNPS(false);
      }, 5000);
    }

    return () => clearTimeout(timer);
  }, [submitted]);

  const onSelectScore = (score) => {
    setSelectedScore(score);
    segmentAnalytics.trackNPSScoreSelect(score);
  };

  const onSubmitComment = (comment) => {
    setSubmitted(true);
    segmentAnalytics.trackNPSCommentSubmit(selectedScore, comment);
  };

  const onClose = () => {
    setShowNPS(false);

    if (selectedScore === undefined) {
      segmentAnalytics.trackNPSDismiss();
    }
  };

  let content = null;

  if (showNPS) {
    content = (
      <NPS
        onClose={onClose}
        key="nps"
        onSubmitComment={onSubmitComment}
        onSelectScore={onSelectScore}
        {...props}
      />
    );
  }

  return (
    <div className={props.classes.root}>
      <ReactCSSTransitionGroup
        transitionName={props.classes.nps}
        transitionEnterTimeout={300}
        transitionLeaveTimeout={300}>
        {content}
      </ReactCSSTransitionGroup>
    </div>
  );
};

export default withStyles(styles)(ConnectedNPS);
